<script>
import ScrollBoxMobile from './ScrollBoxMobile';

export default ScrollBoxMobile;
</script>
